import React from "react";
import "../../src/styles/Work/WorkDetails/WorkDetails.scss";
import { Col, Container, Row } from "react-bootstrap";
import workImageBanner from "../../src/assets/images/blogDetailsBannerImage.png";
const WorkDetails = () => {
  return (
    <Container fluid>
      <Container className="work-details-container">
        <Row>
          <Col md={2}>
            <div className="work-details-title">Mezro</div>
          </Col>
          <Col md={10}>
            <p className="work-details-description">
              Gather and evaluate user requirements in collaboration with
              product managers and engineers Illustrate design ideas using
              storyboards, process flows and sitemaps Design graphic user
              interface elements, like menus, tabs and widgets Build page
              navigation buttons and search fields Develop UI mockups and
              prototypes that clearly illustrate how sites function and look
              like Create original graphic designs (e.g. images, sketches and
              tables) Prepare and present rough drafts to internal teams and key
              stakeholders Identify and troubleshoot UX problems (e.g.
              responsiveness) Conduct layout adjustments based on user feedback
              Adhere to style standards on fonts, colors and image
            </p>
          </Col>
        </Row>
        <div className="work-image-banner">
          <img src={workImageBanner} alt="banner-img" className="img-fluid" />
        </div>
        <div className="work-image-banner">
          <img src={workImageBanner} alt="banner-img" className="img-fluid" />
        </div>
      </Container>
    </Container>
  );
};

export default WorkDetails;
